import { Box, Tab, Tabs } from '@mui/material';
import { object, oneOf } from 'prop-types';
import React, { Component } from 'react';
import { I18n } from 'utils/i18n';
import connector from './connector';
import Documents from './Documents';
import Forms from './Forms';
import Links from './Links';
import Media from './Media';
import TabContent from './TabContent';

class MediaTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: props.tab,
    };
  }

  changeTab = (e, value) => {
    this.props.actions.media.change({ type: value });
    this.setState({ tab: value });
  };

  render() {
    const { tab } = this.state;

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          margin: '15px',
        }}
      >
        <Tabs
          value={tab}
          variant="fullWidth"
          onChange={this.changeTab}
          sx={theme => ({
            borderBottom: `1px solid ${theme.palette.divider}`,
          })}
          TabIndicatorProps={{
            sx: theme => ({
              backgroundColor: theme.palette.black,
            }),
          }}
        >
          <Tab value="doc" label={I18n.t('MediaDrawer.Docs')} />
          <Tab value="media" label={I18n.t('MediaDrawer.Media')} />
          <Tab value="link" label={I18n.t('MediaDrawer.Links')} />
          <Tab value="form" label={I18n.t('MediaDrawer.Forms')} />
        </Tabs>
        <TabContent current={tab} value="doc">
          <Documents />
        </TabContent>
        <TabContent current={tab} value="media">
          <Media />
        </TabContent>
        <TabContent current={tab} value="link">
          <Links />
        </TabContent>
        <TabContent current={tab} value="form">
          <Forms />
        </TabContent>
      </Box>
    );
  }
}

MediaTabs.propTypes = {
  tab: oneOf(['media', 'doc', 'link']).isRequired,
  actions: object.isRequired,
};

export default connector(MediaTabs);
